import React from "react";
import { Diamond } from "lucide-react";
import { TICKER_WORDS } from "../lib/kk";

export const Ticker = () => {
  const items = [...TICKER_WORDS, ...TICKER_WORDS];
  return (
    <div className="kk-ticker" data-testid="ticker-band">
      <div className="kk-ticker-track">
        {items.map((word, i) => (
          <span className="kk-ticker-item" key={i}>
            <span>{word}</span>
            <Diamond size={12} color="#BB0000" fill="#BB0000" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
